function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><g data-name="Group 1"><path fill="currentColor" d="M11.293 23.933a10.5 10.5 0 0 1 1.083-20.924V.185a.2.2 0 0 1 .328-.142l5.815 4.27a.179.179 0 0 1 0 .289l-5.815 4.27a.2.2 0 0 1-.328-.142V5.911a7.6 7.6 0 1 0 7.629 8.815 1.446 1.446 0 0 1 2.858.436 10.512 10.512 0 0 1-11.57 8.771z" data-name="Path 1" /><path fill="none" data-name="Rectangle 1" d="M0 0h24v24H0z" /></g></svg>;
});